// Conserva exclusivamente informações já existentes nas observações da Sponte.
// Aceita tanto os marcadores *** quanto resumos antigos que perderam asteriscos.
export const readRetiredEnrollmentFields = (observation = '') => {
  const text = String(observation || '');
  const headings = 'ASPECTOS DE SAUDE|ASPECTO DE SAUDE HISTORICO|CONTATOS EMERGENCIA|VENCIMENTO BOLETO|AUTORIZACOES|RESTRICOES DIREITO DE IMAGEM|DIREITO DE IMAGEM|FORMA DE PAGAMENTO|COR RACA';
  const section = (heading) => {
    const match = text.match(new RegExp(`(?:\\*{3}\\s*)?${heading}\\s*(?:\\*{3})?\\s*([\\s\\S]*?)(?=\\s*(?:\\*{3}\\s*)?(?:${headings})\\b|$)`, 'i'));
    return match?.[1]?.replace(/^[\s*]+|[\s*]+$/g, '') || '';
  };
  const emergencyContacts = section('CONTATOS EMERGENCIA');
  const dueDate = section('VENCIMENTO BOLETO');
  const medicalTreatment = section('ASPECTO DE SAUDE HISTORICO') ||
    section('ASPECTOS DE SAUDE').match(/Tratamento medico(?:\s*\([^)]*\))?/i)?.[0] || '';
  return {
    emergencyContacts: emergencyContacts ? `*** CONTATOS EMERGENCIA *** ${emergencyContacts}` : '',
    dueDate: dueDate ? `*** VENCIMENTO BOLETO *** ${dueDate}` : '',
    medicalTreatment,
  };
};
